import React from 'react';
import { MenuItem, MenuList } from '@mui/material';
import i18n from '../../../i18';
import { ArrowRightBoldIcon } from '../../../icons-lib';
import { alpha } from '@mui/material/styles';

export const FilterList = ({
    filters,
    onFilterSelect,
    selectedFiltersField
}) => {
    const isSelected = (field) => selectedFiltersField.includes(field);
    return (
        <MenuList>
            {filters.map((filter) => (
                <MenuItem
                    key={filter.field}
                    onClick={() => onFilterSelect(filter)}
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        backgroundColor: isSelected(filter.filterField)
                            ? (theme) => alpha(theme.palette.primary.main, 0.1)
                            : 'inherit'
                    }}
                >
                    {i18n.t(`columns.${filter.label}`)}
                    <ArrowRightBoldIcon />
                </MenuItem>
            ))}
        </MenuList>
    );
};
